import { Theme } from '@mui/material/styles'

const muiTabs = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        minHeight: '2.625rem',
        '& .MuiTabs-flexContainerVertical': {
          '& .MuiTab-root': {
            marginRight: 0,
            marginBottom: '0.75rem',
            padding: '0rem 1rem',
            '&:last-child': {
              marginBottom: 0
            }
          }
        },
        '& .MuiTab-root': {
          minHeight: '2.625rem',
          marginRight: '1.5rem',
          '&:last-child': {
            marginRight: 0
          }
        }
      }
    }
  }
}

export default muiTabs
